<template>
  <div class="recipe-content-attr">
    <div class="recipe-content-attr__rating">
      <ica-rating
        :show-user-rate="true"
        :average-rating="averageRating"
        :user-rated="customerRating"
        :votes="numberOfVotes"
        :size="20"
      />
    </div>
    <div class="recipe-content-attr__comments">
      <svgicon
        class="recipe-content-attr__icon"
        name="Communication/Comment"
      />
      <span>{{ numberOfComments || 0 }}</span>
    </div>
    <div
      v-if="isGoodClimateChoice"
      aria-label="Bra klimatval"
      class="recipe-content-attr__climate"
      :class="{'recipe-content-attr--no-climate-text': !showClimateText}"
    >
      <svgicon
        class="recipe-content-attr__icon"
        name="Climate/ClimateGuide"
      />
      <span
        v-if="showClimateText"
        class="recipe-content-attr__climate--text"
      >Klimatsmart</span>
    </div>
  </div>
</template>

<script>
import "#/Communication/Comment"
import "#/Climate/ClimateGuide"

export default {
  name: "RecipeContentAttributes",
  props: {
    isSize: {
      type: Object,
      default () {
        return {
          full: true
        }
      }
    },
    isHighlight: {
      type: Boolean,
      default: false
    },
    averageRating: {
      type: Number,
      default: 0
    },
    customerRating: {
      type: Number,
      default: 0
    },
    numberOfVotes: {
      type: Number,
      default: 0
    },
    numberOfComments: {
      type: Number,
      default: 0
    },
    isGoodClimateChoice: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    showClimateText () {
      if (this.$root.isSmallViewport) {
        return this.isHighlight
      } else if (this.$root.isMediumViewport) {
        return !this.isHighlight
      } else if (this.$root.currentSizeEquals('lg')) {
        return !this.isSize.third
      } else if (this.$root.currentSizeGte('xl')) {
        return !this.isSize.quarter
      }
      return false
    },
  }
}
</script>

<style lang="scss">
  .recipe-content-attr {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    color: $color-secondary-text;

    .base-block-epi--media-right-small & {
      margin-top: 0.25rem;
    }

    > div {
      @include font(text, 2, "bold");

      display: flex;
      align-items: center;
      line-height: normal;
      margin-right: 0.5rem;
    }

    &__icon {
      width: 1.25rem;
      height: 1.25rem;
      fill: $color-secondary-text;
      margin-right: 0.25rem;
    }

    &__climate {
      line-height: 1.5rem;
      color: $color-climate;

      .svg-icon {
        fill: $color-climate;
      }
    }

    & &--no-climate-text {
      margin-right: 0;

      svg {
        margin-right: 0;
      }
    }
  }

  .base-block-epi--quarter,
  .base-block-epi--third {
    .recipe-content-attr {
      justify-content: start;

      &__rating {
        justify-content: start;
        margin-left: -0.125rem;
      }

      @include media-breakpoint-down(sm) {
        > div {
          @include font(text, 2, "bold");

          .recipe-content-attr__icon {
            height: 1.25rem;
          }
        }

        .recipe-content-attr__comments {
          line-height: 1.5rem;
        }
      }
    }

    @include media-breakpoint-up(md) {
      .recipe-content-attr {
        justify-content: center;

        .recipe-content-attr__rating {
          margin-left: 0;
        }
      }
    }

    @include media-breakpoint-up(lg) {
      .recipe-content-attr {
        justify-content: start;

        .recipe-content-attr__rating {
          margin-left: -0.125rem;
        }
      }
    }
  }
</style>
